import { Grid } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import { cabecalhoTransformacaoRegras } from '../../../../types/tabelaTypes'
import { AbaTabela } from './../AbaTabela'
import { TabTransformacaoApiIO } from './TabTransformacaoApi.IO'
import { ItemTransformacaoApi } from './../ItemTransformacaoApi'
import { Botao } from './../../../../components/Botao/index'
import { ModalPriorizarTransformacaoApi } from '../ModalPriorizarTransformacaoApi/Index'

export type TabTransformacaoApiProps = {}

export default function TabTransformacaoApiView({ _io }: IOProps<TabTransformacaoApiIO, TabTransformacaoApiProps>) {
  const { Container } = _io.styles
  const parceiroNaoHabilitado = !!_io.erroTransformacaoApi

  function linhaTabela(props: { item: any; index: number }) {
    const { item, index } = props

    return <ItemTransformacaoApi key={index} linhaItemTransformacao={item} index={index} atualizarDados={_io.buscarRegrasTransformacao} />
  }

  return (
    <>
      <Container>
        <Grid container direction="row" spacing={2} justifyContent="flex-end">
          <Grid item>
            <Botao onClick={_io.handlePriorizar} textoBotao="Priorizar" cor="primaria" estilo="outlined" disabled={parceiroNaoHabilitado} />
          </Grid>
          <Grid item>
            <Botao onClick={_io.handleAdicionar} textoBotao="Adicionar" cor="primaria" estilo="contained" disabled={parceiroNaoHabilitado} />
          </Grid>
        </Grid>
        <AbaTabela
          orderId={''}
          listItem={_io.regrasList}
          headCells={cabecalhoTransformacaoRegras}
          LinhaTabela={linhaTabela}
          mensagemVazia={parceiroNaoHabilitado ? _io.erroTransformacaoApi ?? undefined : 'Nenhum item cadastrado!'}
        ></AbaTabela>
      </Container>
      <ModalPriorizarTransformacaoApi
        isShow={_io.modalAberto}
        isClosed={_io.fecharModal}
        atualizarDados={_io.buscarRegrasTransformacao}
        campos={_io.getCampos()}
        regrasList={_io.regrasList}
        parceiroId={_io.parceiroId}
      />
    </>
  )
}
